<template>
    <div>
        <div class="top">
            <div class="banner">
                <!-- <div class="top_left">
                    <p style="line-height:68px;text-align: center;"><img style="width:110px;" src="../assets/logo.png" alt=""></p>
                </div> -->
                <div class="top_center">
                    <ul class="top_ul">
                        <li class="top_li"  @click="fuwu()">
                            服务介绍
                            <div v-if="fwjs == true" class="active"></div>
                        </li>
                        <li class="top_li"  @click="kehu()">
                            客户案例
                            <div v-if="khal == true" class="active"></div>
                        </li>
                        <li class="top_li" @click="hangye()">
                            行业优势
                            <div v-if="hyys == true" class="active"></div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="banner_img" style="position: relative;">
            <img style="width:100%;margin-top:72px;" src="../assets/banner.png" alt="">
        </div>
        <div class="mefuwu" ref="obtain_mefu" id="mefuwu">
            <div class="banner" style="margin-top:75px;">
                <p class="mefuwu_title">我们的服务</p>
                <p class="mefuwu_heng"></p>
                <ul class="mefuwu_ul">
                    <li class="mefuwu_li">
                        <div class="me_li_div" ref="mediv_p1">
                                <p >
                                    <img style="width:152px;height:120px;margin-top:40px;" src="../assets/keyword.png" alt="">
                                </p>
                                <p class="me_li_title">ASO 关键词优化</p>
                                <p class="me_li_di"></p>
                                <p class="me_li_p" style="margin-top: 11px;">大幅提升增加关键词覆盖量</p>
                                <p class="me_li_p">关键词排名快速提升、效果稳定</p>
                                <p class="me_li_p">快速提升用户下载量</p>
                        </div>
                    </li>
                    <li class="mefuwu_li">
                        <div class="me_li_div" ref="mediv_p3">
                            <p>
                                <img style="width:116px;height:158px;margin-top:27px;" src="../assets/youhua.png" alt="">
                            </p>
                            <p class="me_li_title" style="margin-top: 25px;">ASA搜索广告</p>
                            <p class="me_li_di"></p>
                            <p class="me_li_p" style="margin-top: 12px;">官方授权代理</p>
                            <p class="me_li_p">自有智投平台</p>
                            <p class="me_li_p">独家营销策略 精准获量</p>
                        </div>
                    </li>
                    <li class="mefuwu_li">
                        <div class="me_li_div" ref="mediv_p2">
                            <p>
                                <img style="width:126px;height:122px;margin-top:38px;" src="../assets/bangdan.png" alt="">
                            </p>
                            <p class="me_li_title">榜单优化</p>
                            <p class="me_li_di"></p>
                            <p class="me_li_p" style="margin-top: 11px;">真人用户有效下载</p>
                            <p class="me_li_p">提升APP榜单排名</p>
                            <p class="me_li_p">曝光量指数级增长</p>
                            <p class="me_li_p">扩大产品品牌影响力</p>
                        </div>
                    </li>
                    
                    <li class="mefuwu_li">
                        <div class="me_li_div" ref="mediv_p4">
                            <p>
                                <img style="width:116px;height:158px;margin-top:27px;" src="../assets/fenxi.png" alt="">
                            </p>
                            <p class="me_li_title" style="margin-top: 25px;">竞品分析</p>
                            <p class="me_li_di"></p>
                            <p class="me_li_p" style="margin-top: 11px;">深入行业研究</p>
                            <p class="me_li_p">贴合市场定位</p>
                            <p class="me_li_p">一站式解决方案</p>
                            <p class="me_li_p">产品优化保驾护航</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="hezuo" ref="obtain_hezuo" id="hezuo">
            <div class="banner">
                <p class="mefuwu_title" style="margin-top:80px;">合作伙伴</p>
                <p class="mefuwu_heng"></p>
                <el-carousel :interval="4000" @change='((pre, next) => {change(pre, next)})' ref="carousel" indicator-position="outside" style="margin-top:60px;background:rgba(255,255,255,1);
                                                                box-shadow:0px 15px 30px 20px rgba(13,31,83,0.06);
                                                                border-radius:10px;">
                    <el-carousel-item>
                        <div style="width:100%;height:100px;">
                            <div style="float:left">
                                <div style="float:left">
                                    <img style="width:53px;height:53px;margin:33px 20px 0px 70px;" src="../assets/zuqiu.png" alt="">
                                </div>
                                <div style="float:left">
                                    <p class="mefen_p">全民冠军足球</p>
                                    <p class="mefen_p1">腾讯唯一足球经理手游</p>
                                </div>
                            </div>
                            <div style="float:right;margin-right:110px">
                                <p class="mefen_p2" style="margin-top:53px;">
                                    <span>优化前：关键词覆盖量</span>
                                    <span class="mefen_p3">5K</span>
                                    <span>左右</span>
                                </p>
                                <p class="mefen_p2" style="margin-top:10px;">
                                    <span>优化后：关键词覆盖量</span>
                                    <span class="mefen_p3">1.6W</span>
                                    <span>左右</span>
                                    <span>，提升了</span>
                                    <span class="mefen_p3">220%</span>
                                </p>
                            </div>
                        </div>
                        <div id="myChart" :style="{width: '1060px', height: '400px'}" style="z-index:899;margin:auto;"></div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div>
                            <div style="height:130px;float:left">
                                <div style="float:left">
                                    <img style="width:53px;height:53px;margin:33px 20px 0px 70px;" src="../assets/youku.png" alt="">
                                </div>
                                <div style="float:left">
                                    <p class="mefen_p">优酷视频</p>
                                    <p class="mefen_p1">视频类</p>
                                    <ul class="mefen_ul">
                                        <li class="mefen_li">
                                            <p style="float:left;font-size:12px;color:rgba(139,149,175,1);">竞品词</p>
                                            <p style="margin-top: 4px;margin-left: 8px;float:left;width:10px;height:10px;background:rgba(95,130,244,1);"></p>
                                        </li>
                                        <li class="mefen_li">
                                            <p style="float:left;font-size:12px;color:rgba(139,149,175,1);">行业词</p>                                            
                                            <p style="margin-top: 4px;margin-left: 8px;float:left;width:10px;height:10px;background:rgba(255,147,109,1);"></p>
                                        </li>
                                        <li class="mefen_li">
                                            <p style="float:left;font-size:12px;color:rgba(139,149,175,1);">App store排名</p>
                                            <p style="margin-top: 4px;margin-left: 8px;float:left;width:10px;height:10px;background:rgba(249,122,125,1);"></p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div style="height:130px;float:right;margin-right:110px;">
                                <p class="mefen_p2" style="margin-top:53px;">
                                    <span>优化前：该类词排名基本在</span>
                                    <span class="mefen_p3">T10</span>
                                    <span>外</span>
                                </p>
                                <p class="mefen_p2" style="margin-top:10px;">
                                    <span>优化后：该关键词均已达到</span>
                                    <span class="mefen_p3">T3</span>
                                    <span>内</span>
                                </p>
                            </div>
                            <div style="width:1060px;height:400px;margin:auto;position: relative;">
                                <img style="width:1060px;" src="../assets/zhuzhuang.png" alt="">
                                <div class="me_fir">
                                    <p v-if="xianshi ==false" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:none">2</p>
                                    <p v-if="xianshi ==true" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:block">2</p>
                                    <p class="triangle-up" style="margin-left:4.5px;"></p>
                                    <p ref="ele" style="border-left: 3px dashed rgba(249,122,125,1);width:1px;height:40px;line-height:1px;margin-left:9.5px;"></p>
                                    <p style="font-size:15px;color:rgba(249,122,125,1);margin-left:2px;">38</p>
                                </div>
                                <div class="me_two">
                                    <p v-if="xianshi1 ==false" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:none">3</p>
                                    <p v-if="xianshi1 ==true" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:block">3</p>
                                    <p class="triangle-up" style="margin-left:4.5px;"></p>
                                    <p ref="ele1" style="border-left: 3px dashed rgba(249,122,125,1);width:1px;height:40px;line-height:1px;margin-left:9.5px;"></p>
                                    <p style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;">7</p>
                                </div>
                                <div class="me_thr">
                                    <p v-if="xianshi2 ==false" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:none">2</p>
                                    <p v-if="xianshi2 ==true" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:block">2</p>
                                    <p class="triangle-up" style="margin-left:4.5px;"></p>
                                    <p ref="ele2" style="border-left: 3px dashed rgba(249,122,125,1);width:1px;height:40px;line-height:1px;margin-left:9.5px;"></p>
                                    <p style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;">4</p>
                                </div>
                                <div class="me_fou">
                                    <p v-if="xianshi3 ==false" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:none">2</p>
                                    <p v-if="xianshi3 ==true" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:block">2</p>
                                    <p class="triangle-up" style="margin-left:4.5px;"></p>
                                    <p ref="ele3" style="border-left: 3px dashed rgba(249,122,125,1);width:1px;height:40px;line-height:1px;margin-left:9.5px;"></p>
                                    <p style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;">8</p>
                                </div>
                                <div class="me_fiv">
                                    <p v-if="xianshi4 ==false" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:none">3</p>
                                    <p v-if="xianshi4 ==true" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:block">3</p>
                                    <p class="triangle-up" style="margin-left:4.5px;"></p>
                                    <p ref="ele4" style="border-left: 3px dashed rgba(249,122,125,1);width:1px;height:40px;line-height:1px;margin-left:9.5px;"></p>
                                    <p style="font-size:15px;color:rgba(249,122,125,1);margin-left:2px;">12</p>
                                </div>
                                <div class="me_six">
                                    <p v-if="xianshi5 ==false" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:none">2</p>
                                    <p v-if="xianshi5 ==true" style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;display:block">2</p>
                                    <p class="triangle-up" style="margin-left:4.5px;"></p>
                                    <p ref="ele5" style="border-left: 3px dashed rgba(249,122,125,1);width:1px;height:40px;line-height:1px;margin-left:9.5px;"></p>
                                    <p style="font-size:15px;color:rgba(249,122,125,1);margin-left:7px;">7</p>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div style="width:100%;height:100px;">
                            <div style="float:left">
                                <div style="float:left">
                                    <img style="width:53px;height:53px;margin:33px 20px 0px 70px;" src="../assets/xeicheng.png" alt="">
                                </div>
                                <div style="float:left">
                                    <p class="mefen_p">携程金融</p>
                                    <p class="mefen_p1">金融类</p>
                                </div>
                            </div>
                            <div style="float:right;margin-right:110px">
                                <p class="mefen_p2" style="margin-top:53px;">
                                    <span>优化前：该教育榜单排名基本在</span>
                                    <span class="mefen_p3">T1300</span>
                                    <span>左右</span>
                                </p>
                                <p class="mefen_p2" style="margin-top:10px;">
                                    <span>优化后：该教育榜单排名已达到</span>
                                    <span class="mefen_p3">T70</span>
                                    <span>内</span>
                                </p>
                            </div>
                        </div>
                        <div id="myChart1" :style="{width: '1060px', height: '400px'}" style="z-index:899;margin:auto;"></div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div style="width:100%;height:100px;">
                            <div style="float:left">
                                <div style="float:left">
                                    <img style="width:53px;height:53px;margin:33px 20px 0px 70px;" src="../assets/puxin.png" alt="">
                                </div>
                                <div style="float:left">
                                    <p class="mefen_p">朴新网校</p>
                                    <p class="mefen_p1">教育类</p>
                                </div>
                            </div>
                            <div style="float:right;margin-right:110px;">
                                <p class="mefen_p2" style="margin-top:53px;">
                                    <span>优化前：该教育类下载量在</span>
                                    <span class="mefen_p3">100个</span>
                                    <span>左右</span>
                                </p>
                                <p class="mefen_p2" style="margin-top:10px;">
                                    <span>优化后：该教育类下载量已达</span>
                                    <span class="mefen_p3">3K</span>
                                    <span>左右，提升了</span>
                                    <span class="mefen_p3">2900%</span>
                                </p>
                            </div>
                        </div>
                        <div id="myChart2" :style="{width: '1060px', height: '400px'}" style="z-index:899;margin:auto;"></div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="wemen" ref="obtain_wemen" id="wemen">
            <div class="banner" style="margin-top:108px;">
                <p class="mefuwu_title" style="margin-top:64px;">我们的优势</p>
                <p class="mefuwu_heng"></p>
                <ul class="wemen_ul" ref="wemen_ulp">
                    <li class="wemen_li">
                        <a href="http://p.qiao.baidu.com/cps/chat?siteId=14888409&userId=30332362" target="_blank">
                            <div style="float: left;">
                                <img style="width:53px;margin:42px 26px 0px 40px;" src="../assets/celue.png" alt="">
                            </div>
                            <div style="float: left;">
                                <p class="wemen_p">ASO策略支持</p>
                                <p class="wemen_p1">多年大厂iOS增长背景团队提供运营策略支持</p>
                            </div>
                        </a>
                    </li>
                    <li class="wemen_li">
                        <a href="http://p.qiao.baidu.com/cps/chat?siteId=14888409&userId=30332362" target="_blank">
                            <div style="float: left;">
                                <img style="width:53px;margin:42px 26px 0px 40px;" src="../assets/liuliang.png" alt="">
                            </div>
                            <div style="float: left;">
                                <p class="wemen_p">流量整合能力</p>
                                <p class="wemen_p1">全网灵活高效积分墙用户整合，为冲榜、冲词提供保障</p>
                            </div>
                        </a>
                    </li>
                    <li class="wemen_li">
                        <a href="http://p.qiao.baidu.com/cps/chat?siteId=14888409&userId=30332362" target="_blank">
                            <div style="float: left;">
                                <img style="width:53px;margin:42px 26px 0px 40px;" src="../assets/pingguo.png" alt="">
                            </div>
                            <div style="float: left;">
                                <p class="wemen_p" style="margin-top: 26px;">苹果关系</p>
                                <p class="wemen_p1">及时帮助客户高效快速沟通苹果相关负责人，为清词，清榜，下架，上包卡审问题做出精确解答</p>
                            </div>
                        </a>
                    </li>
                    <li class="wemen_li">
                        <a href="http://p.qiao.baidu.com/cps/chat?siteId=14888409&userId=30332362" target="_blank">
                            <div style="float: left;">
                                <img style="width:53px;margin:42px 26px 0px 40px;" src="../assets/jingyan.png" alt="">
                            </div>
                            <div style="float: left;">
                                <p class="wemen_p">相关行业经验</p>
                                <p class="wemen_p1">深度跟进剖析总结游戏类app用户增长方法</p>
                            </div>
                        </a>
                    </li>
                    <li class="wemen_li">
                        <a href="http://p.qiao.baidu.com/cps/chat?siteId=14888409&userId=30332362" target="_blank">
                            <div style="float: left;">
                                <img style="width:53px;margin:42px 26px 0px 40px;" src="../assets/zhuanshu.png" alt="">
                            </div>
                            <div style="float: left;">
                                <p class="wemen_p">专属服务</p>
                                <p class="wemen_p1">高效快速响应，7*24支持，驻场支持</p>
                            </div>
                        </a>
                    </li>
                    <li class="wemen_li">
                        <a href="http://p.qiao.baidu.com/cps/chat?siteId=14888409&userId=30332362" target="_blank">
                            <div style="float: left;">
                                <img style="width:53px;margin:42px 26px 0px 40px;" src="../assets/huibao.png" alt="">
                            </div>
                            <div style="float: left;">
                                <p class="wemen_p" style="margin-top: 26px;">精确汇报</p>
                                <p class="wemen_p1">每日完成前一日工作日报反馈，并邮件确认，根据客户需要提供周报、月报及实施会议汇报工作</p>
                            </div>
                        </a>
                    </li>
                    <li class="wemen_li">
                        <a href="http://p.qiao.baidu.com/cps/chat?siteId=14888409&userId=30332362" target="_blank">
                            <div style="float: left;">
                                <img style="width:53px;margin:42px 26px 0px 40px;" src="../assets//guangdu.png" alt="">
                            </div>
                            <div style="float: left;">
                                <p class="wemen_p">行业广度</p>
                                <p class="wemen_p1">搜狐、58、美团、淘宝、优酷、腾讯游戏等等大厂的选择</p>
                            </div>
                        </a>
                    </li>
                    <li class="wemen_li">
                        <a href="http://p.qiao.baidu.com/cps/chat?siteId=14888409&userId=30332362" target="_blank">
                            <div style="float: left;">
                                <img style="width:53px;margin:42px 26px 0px 40px;" src="../assets/jiyin.png" alt="">
                            </div>
                            <div style="float: left;">
                                <p class="wemen_p">公司基因</p>
                                <p class="wemen_p1">核心团队甲方经验，更理解客户需求，方便高效沟通</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="buttom" >
            <div class="banner" style="text-align: center">
                <p class="buttom_p">总部：北京市朝阳区来广营诚盈中心五号楼 1502室</p>
                <p class="buttom_bo">
                    <a href="http://www.beian.miit.gov.cn/">北京秦点信息科技有限公司 版权所有 京ICP备2021004698号</a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
// import animate from 'animate.css';
// import $ from 'jquery';
// 引入基本模板
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/pie");
require("echarts/lib/chart/line");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require('echarts/lib/component/dataZoom');
export default {
    data () {
        return {
            showTijiao:false,
            fwjs : true,
            khal : false,
            hyys : false,
            lxwm : false,
            fir : false,
            two : false,
            thr : false,
            fou : false,
            dongcl: false,
            xianshi : false,
            xianshi1 : false,
            xianshi2 : false,
            xianshi3 : false,
            xianshi4 : false,
            xianshi5 : false,
            name : '',
            tel : '',
            appname: '',
            textarea :'',
            myChart:'',
            myChart1:'',
            myChart2:'',
            Option : {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ['全部关键词覆盖量', '关键词覆盖量前三', '关键词覆盖量前十'],
                    left:'70',
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#CECFD1",
                                width: 2,
                            }
                        },
                        boundaryGap: false,
                        data: ['01-07', '01-08', '01-09', '01-10', '01-11', '01-12'],
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#95A4B3',  //更改坐标轴文字颜色
                                fontSize : 13,      //更改坐标轴文字大小
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            show: true,
                                textStyle: {
                                    color: '#95A4B3',  //更改坐标轴文字颜色
                                    fontSize : 11,      //更改坐标轴文字大小
                                }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#CECFD1",
                                width: 2,
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#CECFD1',
                                type:'dashed'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '全部关键词覆盖量',
                        type: 'line',
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: "#5F82F4",
                                lineStyle: {
                                    color: "#5F82F4",
                                    }
                            }
                        },
                        data: [3168, 3149, 3124, 5940, 16847, 16847]
                    },
                    {
                        name: '关键词覆盖量前三',
                        type: 'line',
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: "#FF6A37",
                                lineStyle: {
                                    color: "#FF6A37",
                                    }
                            }
                        },
                        data: [127, 130, 129, 1011, 4411, 4064]
                    },
                    {
                        name: '关键词覆盖量前十',
                        type: 'line',
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: "#7AF9DD",
                                lineStyle: {
                                    color: "#7AF9DD",
                                    }
                            }
                        },
                        data: [325, 323, 318, 1745, 6775, 6696]
                    }
                ]
            },
            Option1 : {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ['财务榜排名'],
                    left:'70',
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        axisLine: {
                            onZero: false,
                            lineStyle: {
                                color: "#CECFD1",
                                width: 2,
                            }
                        },
                        data: ['09-06', '09-12', '09-19', '09-26', '10-03', '10-10', '10-17', '10-24', '10-31', '11-07', '11-14', '11-21', '11-28', '12-05', '12-12', '12-19', '12-26'],
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#95A4B3',  //更改坐标轴文字颜色
                                fontSize : 13,      //更改坐标轴文字大小
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        inverse: true,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#95A4B3',  //更改坐标轴文字颜色
                                fontSize : 11,      //更改坐标轴文字大小
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#CECFD1",
                                width: 2,
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#CECFD1',
                                type:'dashed'
                            }
                        }
                    },
                    {
                        type: 'value',
                        axisLine:{ //y轴
                            show:false
                        },
                    },
                ],
                series: [
                    {
                        name: '财务榜排名',
                        type: 'line',
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: "#FF6A37",
                                lineStyle: {
                                    color: "#FF6A37",
                                }
                            }
                        },
                        data: [765, 695, 611, 607, 379, 431, 388, 351, 340, 257, 256, 189, 173, 153, 139, 133, 28]
                    },
                ]
            },
            Option2 : {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ['预估下载量'],
                    left:'70',
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['05-28', '05-29', '05-30', '05-31', '06-01', '06-02', '06-03', '06-04', '06-05', '06-06', '06-07', '06-08', '06-09', '06-10', '06-11'],
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#CECFD1",
                                width: 2,
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#95A4B3',  //更改坐标轴文字颜色
                                fontSize : 13,      //更改坐标轴文字大小
                                // backgroundcolor:'#95A4B3',
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            show: true,
                                textStyle: {
                                    color: '#95A4B3',  //更改坐标轴文字颜色
                                    fontSize : 11,      //更改坐标轴文字大小
                                }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#CECFD1",
                                width: 2,
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#CECFD1',
                                type:'dashed'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '预估下载量',
                        type: 'line',
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: "#5F82F4",
                                lineStyle: {
                                    color: "#5F82F4",
                                        // "width": 2
                                    }
                            }
                        },
                        data: [140, 126, 152, 246, 306, 394, 681, 936, 1475, 1810, 1994, 1142, 1244, 2374, 2805]
                    },
                ]
            },
            thisOption : '',
            testid : '',
            test : '',
            nameis : '请输入您的姓名',
            nameis1 : '请输入您的APP名称',
            nameis2 : '请输入您的联系方式',
            nameis3 : '请写明您的具体需求，以便我们安排相应顾问与您联系',
            ttt : '',
        }
    },
    mounted() {
        this.drawLine(this.Option);
        this.drawLine1(this.Option1);
        this.drawLine2(this.Option2);
        this.submit()
        this.jsss()
        window.addEventListener('scroll', this.handleScrollx, true)
        window.addEventListener('scroll', this.handleScrollx1, true)
        window.addEventListener('scroll', this.handleScrollx2, true)
        window.addEventListener('scroll', this.handleScrollx3, true)

        
    },
    watch: {
        Option:{
            handler(newVal){
                this.$nextTick(() =>{
                    this.myChart.setOption(newVal,true);
                })
            },
            deep:true
        },
        Option1:{
            handler1(newVal1){
                this.$nextTick(() =>{
                    this.myChart1.setOption(newVal1,true);
                })
            },
            deep:true
        },
        Option2:{
            handler2(newVal2){
                this.$nextTick(() =>{
                    this.myChart2.setOption(newVal2,true);
                })
            },
            deep:true
        },
    },
    methods: {
        submit(){
            this.test = window.location.href
            this.testid = returnCitySN["cip"]
            this.$Axios({
                url:"https://api.baifutui.com/land/log/addPc" ,
                method:"post",
                headers: {
                    'Content-Type' : 'application/json',
                },
                data: {
                    body:{
                        ip : this.testid,
                        url : this.test,
                    }
                }
            }).then((result)=>{ 
                // console.log(result)
            })
        },
        search(){
            if(this.name == ''){
                this.nameis = '请输入您的姓名'
            }
        },
        search1(){
            if(this.name == ''){
                this.nameis = ''
            }
        },
        search3(){
            if(this.appname == ''){
                this.nameis1 = '请输入您的APP名称'
            }
        },
        search2(){
            if(this.appname == ''){
                this.nameis1 = ''
            }
        },
        search4(){
            if(this.tel == ''){
                this.nameis2 = '请输入您的联系方式'
            }
        },
        search5(){
            if(this.tel == ''){
                this.nameis2 = ''
            }
        },
        search6(){
            if(this.textarea == ''){
                this.nameis3 = '请写明您的具体需求，以便我们安排相应顾问与您联系'
            }
        },
        search7(){
            if(this.textarea == ''){
                this.nameis3 = ''
            }
        },
        fuwu(selector){
            this.fwjs = true;
            this.khal = false;
            this.hyys = false;
            this.lxwm = false;
            document.getElementById("mefuwu").scrollIntoView({
                behavior:"smooth",
                block:"start"
            })
        },
        kehu(selector){
            this.fwjs = false;
            this.khal = true;
            this.hyys = false;
            this.lxwm = false;
            document.getElementById("hezuo").scrollIntoView({
                behavior:"smooth",
                block:"start"
            })
        },
        hangye(selector){
            this.fwjs = false;
            this.khal = false;
            this.hyys = true;
            this.lxwm = false;  
            document.getElementById("wemen").scrollIntoView({
                behavior:"smooth",
                block:"start"
            })
        },
        lianxi(){
            this.fwjs = false;
            this.khal = false;
            this.hyys = false;
            this.lxwm = true;
            document.getElementById("fangshi").scrollIntoView({
                behavior:"smooth",
                block:"start"
            })
        },
        enter(){
            this.fir = true;
        },
        leave(){
            this.fir = false;
        },
        enter1(){
            this.two = true;
        },
        leave1(){
            this.two = false;
        },
        enter2(){
            this.thr = true;
        },
        leave2(){
            this.thr = false;
        },
        enter3(){
            this.fou = true;
        },
        leave3(){
            this.fou = false;
        },
        // ljzx(){
        //     this.testid = returnCitySN["cip"]
        //     // alert(1)
        //     this.$Axios({
        //         url:"https://api.baifutui.com/land/landing/addPc" ,
        //         method:"post",
        //         headers: {
        //             'Content-Type' : 'application/json',
        //         },
        //         data: {
        //             body:{
        //                 name : this.name,
        //                 phone : this.tel,
        //                 appName : this.appname,
        //                 content : this.textarea,
        //                 ip : this.testid,
        //             }
        //         }
        //     }).then((result)=>{
        //         if(result.data.code !== 2000){
        //             alert(result.data.msg)
        //         }
        //         if(result.data.code == 2000){
        //             alert("您的信息提交成功")
        //             this.name = '';
        //             this.tel = '';
        //             this.appname = '';
        //             this.textarea = '';
        //         }
        //     })
        // },
        handleScrollx() {
            if(this.$refs.obtain_mefu.getBoundingClientRect().top <= 80){
                this.dongcl = true;
                this.fwjs = true;
                this.khal = false;
                this.hyys = false;
                this.lxwm = false;
            }
            if(this.$refs.mediv_p1.getBoundingClientRect().top <= 900){
                this.$refs.mediv_p1.classList.add('animated')
                this.$refs.mediv_p1.classList.add('fadeInUpBig')
            }
            if(this.$refs.mediv_p2.getBoundingClientRect().top <= 900){
                this.$refs.mediv_p2.classList.add('animated')
                this.$refs.mediv_p2.classList.add('fadeInUpBig')
            }
            if(this.$refs.mediv_p3.getBoundingClientRect().top <= 900){
                this.$refs.mediv_p3.classList.add('animated')
                this.$refs.mediv_p3.classList.add('fadeInUpBig')
            }
            if(this.$refs.mediv_p4.getBoundingClientRect().top <= 900){
                this.$refs.mediv_p4.classList.add('animated')
                this.$refs.mediv_p4.classList.add('fadeInUpBig')
            }
        },
        handleScrollx1() {
            if(this.$refs.obtain_hezuo.getBoundingClientRect().top <= 120){
                this.fwjs = false;
                this.khal = true;
                this.hyys = false;
                this.lxwm = false;
            }
        },
        handleScrollx2() {
            if(this.$refs.obtain_wemen.getBoundingClientRect().top <= 80){
                this.fwjs = false;
                this.khal = false;
                this.hyys = true;
                this.lxwm = false;
            }
            // wemen_ulp
            if(this.$refs.wemen_ulp.getBoundingClientRect().top <= 700){
                this.$refs.wemen_ulp.classList.add('animated')
                this.$refs.wemen_ulp.classList.add('fadeInUpBig')
            }
        },
        handleScrollx3() {
            if(this.$refs.obtain_fangshi.getBoundingClientRect().top <= 120){
                this.fwjs = false;
                this.khal = false;
                this.hyys = false;
                this.lxwm = true;
            }
        },
        drawLine(Option) {
            var easingFuncs = {
                quarticIn: function (k) {
                    return k * k * k * k;
                },
            }
            var N_POINT = 30;
            var grids = [];
            var xAxes = [];
            var yAxes = [];
            var series = [];
            var titles = [];
            var count = 0;
            echarts.util.each(easingFuncs, function (easingFunc, name) {
                var data = [];
                for (var i = 0; i <= N_POINT; i++) {
                    var x = i / N_POINT;
                    var y = easingFunc(x);
                    data.push([x, y]);
                }
                grids.push({
                    show: true,
                    borderWidth: 0,
                    backgroundColor: '#fff',
                    shadowColor: 'rgba(0, 0, 0, 0.3)',
                    shadowBlur: 2
                });
                xAxes.push({
                    type: 'value',
                    show: false,
                    min: 0,
                    max: 1,
                    gridIndex: count
                });
                yAxes.push({
                    type: 'value',
                    show: false,
                    min: -0.4,
                    max: 1.4,
                    gridIndex: count
                });
                series.push({
                    name: name,
                    type: 'line',
                    xAxisIndex: count,
                    yAxisIndex: count,
                    data: data,
                    showSymbol: false,
                    animationEasing: name,
                    animationDuration: 1000
                });
                titles.push({
                    textAlign: 'center',
                    text: name,
                    textStyle: {
                        fontSize: 12,
                        fontWeight: 'normal'
                    }
                });
                count++;
            });
            // 基于准备好的dom，初始化echarts实例
            this.myChart = echarts.init(document.getElementById("myChart"));
            // 绘制图表
            this.myChart.setOption(Option);
        },
        drawLine1(Option1) {
            var easingFuncs = {
                quarticIn: function (k) {
                    return k * k * k * k;
                },
            }
            var N_POINT = 30;
            var grids = [];
            var xAxes = [];
            var yAxes = [];
            var series = [];
            var titles = [];
            var count = 0;
            echarts.util.each(easingFuncs, function (easingFunc, name) {
                var data = [];
                for (var i = 0; i <= N_POINT; i++) {
                    var x = i / N_POINT;
                    var y = easingFunc(x);
                    data.push([x, y]);
                }
                grids.push({
                    show: true,
                    borderWidth: 0,
                    backgroundColor: '#fff',
                    shadowColor: 'rgba(0, 0, 0, 0.3)',
                    shadowBlur: 2
                });
                xAxes.push({
                    type: 'value',
                    show: false,
                    min: 0,
                    max: 1,
                    gridIndex: count
                });
                yAxes.push({
                    type: 'value',
                    show: false,
                    min: -0.4,
                    max: 1.4,
                    gridIndex: count
                });
                series.push({
                    name: name,
                    type: 'line',
                    xAxisIndex: count,
                    yAxisIndex: count,
                    data: data,
                    showSymbol: false,
                    animationEasing: name,
                    animationDuration: 1000
                });
                titles.push({
                    textAlign: 'center',
                    text: name,
                    textStyle: {
                        fontSize: 12,
                        fontWeight: 'normal'
                    }
                });
                count++;
            });
            // 基于准备好的dom，初始化echarts实例
            this.myChart1 = echarts.init(document.getElementById("myChart1"));
            // 绘制图表
            this.myChart1.setOption(Option1);
        },
        drawLine2(Option2) {
            var easingFuncs = {
                quarticIn: function (k) {
                    return k * k * k * k;
                },
            }
            var N_POINT = 30;
            var grids = [];
            var xAxes = [];
            var yAxes = [];
            var series = [];
            var titles = [];
            var count = 0;
            echarts.util.each(easingFuncs, function (easingFunc, name) {
                var data = [];
                for (var i = 0; i <= N_POINT; i++) {
                    var x = i / N_POINT;
                    var y = easingFunc(x);
                    data.push([x, y]);
                }
                grids.push({
                    show: true,
                    borderWidth: 0,
                    backgroundColor: '#fff',
                    shadowColor: 'rgba(0, 0, 0, 0.3)',
                    shadowBlur: 2
                });
                xAxes.push({
                    type: 'value',
                    show: false,
                    min: 0,
                    max: 1,
                    gridIndex: count
                });
                yAxes.push({
                    type: 'value',
                    show: false,
                    min: -0.4,
                    max: 1.4,
                    gridIndex: count
                });
                series.push({
                    name: name,
                    type: 'line',
                    xAxisIndex: count,
                    yAxisIndex: count,
                    data: data,
                    showSymbol: false,
                    animationEasing: name,
                    animationDuration: 1000
                });
                titles.push({
                    textAlign: 'center',
                    text: name,
                    textStyle: {
                        fontSize: 12,
                        fontWeight: 'normal'
                    }
                });
                count++;
            });
            // 基于准备好的dom，初始化echarts实例
            this.myChart2 = echarts.init(document.getElementById("myChart2"));
            // 绘制图表
            this.myChart2.setOption(Option2);
        },
        change (pre, next) {
            if(pre == 0){
                this.myChart.clear();
                this.drawLine(this.Option);
            }
            if(pre == 1){
                this.xianshi = false
                this.donghua();
                this.donghua1();
                this.donghua2();
                this.donghua3();
                this.donghua4();
                this.donghua5();
            }
            if(pre == 2){
                this.myChart1.clear();
                this.drawLine1(this.Option1);
            }
            if(pre == 3){
                this.myChart2.clear();
                this.drawLine2(this.Option2);
            }
        },
        donghua(){
            var num = 0;
            let time = setInterval(()=>{
                num = num+0.5;
                if(num>80){
                    clearInterval(time)
                    this.xianshi = true;
                }else{
                    this.$refs.ele.style.height = num + 'px'
                    var heightStyle =this.$refs.ele.style.height;
                }
            },15)
        },
        donghua1(){
            var num = 0;
            let time = setInterval(()=>{
                num = num+0.5;
                if(num>40){
                    clearInterval(time)
                    this.xianshi1 = true;
                }else{
                    this.$refs.ele1.style.height = num + 'px'
                    var heightStyle =this.$refs.ele1.style.height;
                }
            },15)
        },
        donghua2(){
            var num = 0;
            let time = setInterval(()=>{
                num = num+0.5;
                if(num>20){
                    clearInterval(time)
                    this.xianshi2 = true;
                }else{
                    this.$refs.ele2.style.height = num + 'px'
                    var heightStyle =this.$refs.ele2.style.height;
                }
            },15)
        },
        donghua3(){
            var num = 0;
            let time = setInterval(()=>{
                num = num+0.5;
                if(num>60){
                    clearInterval(time)
                    this.xianshi3 = true;
                }else{
                    this.$refs.ele3.style.height = num + 'px'
                    var heightStyle =this.$refs.ele3.style.height;
                }
            },15)
        },
        donghua4(){
            var num = 0;
            let time = setInterval(()=>{
                num = num+0.5;
                if(num>80){
                    clearInterval(time)
                    this.xianshi4 = true;
                }else{
                    this.$refs.ele4.style.height = num + 'px'
                    var heightStyle =this.$refs.ele4.style.height;
                }
            },15)
        },
        donghua5(){
            var num = 0;
            let time = setInterval(()=>{
                num = num+0.5;
                if(num>60){
                    clearInterval(time)
                    this.xianshi5 = true;
                }else{
                    this.$refs.ele5.style.height = num + 'px'
                    var heightStyle =this.$refs.ele5.style.height;
                }
            },15)
        },
        jsss(){
            var _hmt = _hmt || [];
            (function() {
                var hm = document.createElement("script");  
                hm.src = "https://hm.baidu.com/hm.js?d55b7b1272a53289f568a076be82f399";
                var s = document.getElementsByTagName("script")[0]; 
                s.parentNode.insertBefore(hm, s);
            })();
        }
    },
}
</script>
<style scoped>
>>>.el-carousel__container{
    height: 500px;
}
>>>.el-carousel__arrow{
    width:40px;
    height:40px;
    background:rgba(238,242,250,1);
    box-shadow:6px 1px 12px 0px rgba(46,66,94,0);
    font-size: 16px;
    color: #333333;
    line-height: 42px;
    text-align: center;
}
>>>.el-carousel__indicators--outside button {
    background-color: #E0EDFF;
    opacity: 1;
    border-radius:2px;
}
>>>.el-carousel__button{
    width:36px;
    height:3px;
}
>>>.el-carousel__indicator--horizontal {
    display: inline-block;
    padding: 12px 0px;
}
>>>.el-carousel__indicators--outside .el-carousel__indicator:hover button {
    background-color: #FF6A37;
    opacity: 1;
    border-radius:2px;
}
>>>.el-carousel__indicator.is-active button {
    background-color: #FF6A37;
    opacity: 1;
    border-radius:2px;
}
>>>.el-carousel__arrow--left {
    left: 10px;
    z-index: 999;
}
>>>.el-carousel__arrow--right {
    right: 10px;
    z-index: 999;
}
.top{
    width: 100%;
    height: 72px;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
}
.banner{
    width: 1200px;
    margin: auto;
}
.top_left{
    width: 120px;
    height: 72px;
    float: left;
}
.top_center{
    width: 500px;
    height: 72px;
    float: left;
}
.top_center1{
	width: 200px;
	height: 72px;
	line-height: 72px;
	float: left;
	color:rgba(104,120,156,1);
	font-size: 16px;
	margin-left: 120px;
}
.top_right{
    width: 120px;
    height: 72px;
    float: right;
}
.top_ul{
    width: 100%;
    height: 72px;
}
.top_li{
    /* width: 66px; */
    height: 72px;
    float: left;
    margin-left: 40px;
    line-height: 72px;
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(104,120,156,1);
    cursor:pointer;
}
.top_li:first-of-type{
    margin-left: 90px;
}
.active{
    width:31px;
    height:3px;
    text-align: center;
    margin: auto;
    border-radius:2px;
    border-bottom: 3px solid rgba(249,121,74,1);
    margin-top: -6px;
}
.top_li:hover .active{
    display: block;
}
.top_p{
    width:120px;
    height:40px;
    background:linear-gradient(90deg,rgba(253,177,129,1) 0%,rgba(249,121,74,1) 100%);
    border-radius:22px;
    font-size:15px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:40px;
    text-align: center;
    margin-top: 16px;
    margin-left: -80px;
}
.mefuwu{
    width: 100%;
    height: 700px;
    background: #fff;
    overflow: hidden;
}
.mefuwu_title{
    font-size:30px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(10,22,49,1);
    line-height:35px;
    letter-spacing:2px;
    text-align: center;
    margin-top: 12px;
}
.mefuwu_heng{
    width:30px;
    height:5px;
    background:linear-gradient(90deg,rgba(255,149,103,1) 0%,rgba(240,94,45,1) 100%);
    border-radius:3px;
    margin: auto;
    margin-top: 18px;
}
.mefuwu_ul{
    width: 100%;
    height: 418px;
    margin-top: 60px;
}
.mefuwu_li{
    width: 25%;
    height: 415px;
    float: left;
}
.me_li_div{
    width: 280px;
    height: 415px;
    margin: auto;
    box-shadow:0px 13px 30px 8px rgba(13,31,83,0.06);
    border-radius:10px;
    text-align: center;
}
.mefuwu_li:hover {
    transform: scale(1.05);
    -webkit-transform: scale(1.05);
    -moz-transform: scale(1.05);
    -o-transform: scale(1.05);
    -ms-transform: scale(1.05);
}
.me_li_title{
    font-size:20px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(10,22,49,1);
    line-height:24px;
    margin-top: 50px;
}
.me_li_di{
    width:23px;
    height:4px;
    background:linear-gradient(90deg,rgba(255,149,103,1) 0%,rgba(240,94,45,1) 100%);
    border-radius:3px;
    margin: auto;
    margin-top: 7px;
}
.me_li_p{
    width:230px;
    height:26px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(122,134,164,1);
    line-height:26px;
    margin: auto;
}
.hezuo{
    width: 100%;
    height: 794px;
    background:rgba(245,249,255,1);
    overflow: hidden;
}
.wemen{ 
    width: 100%;
    height: 840px;
    background: #fff;
    overflow: hidden;
}
.wemen_ul{
    width: 100%;
    height: 544px;
    margin-top: 60px;
}
.wemen_li{
    width: 48%;
    height: 136px;
    float: left;
    margin-top: 15px;
    margin-left: 15px;
    border-radius:8px;
}
.wemen_li:hover{
    box-shadow:0px 6px 30px 14px rgba(13,31,83,0.06);
    border-radius:8px;
}
.wemen_p{
    font-size:20px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(16,28,54,1);
    line-height:33px;
    margin-top: 36px;
}
.wemen_p1{
    width:379px;
    font-size:15px;
    font-family:MicrosoftYaHei;
    color:rgba(122,134,164,1);
    line-height:21px;
    margin-top: 10px;
}
.fangshi{
    width: 100%;
    height: 467px;
    background: url('../assets/buttom.png') no-repeat top center;
    overflow: hidden;
}
.fangshi_title{
    font-size:30px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:35px;
    text-align: center;
    margin-top: 215px;
}
.fangshi_title1{
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:35px;
    text-align: center;
    margin-top: 25px;
}
.fangshi_di{
    width:30px;
    height:5px;
    background:rgba(255,255,255,1);
    border-radius:3px;
    text-align: center;
    margin: auto;
    margin-top: 25px;
}
>>>.el-input__inner{
    border-radius:25px;
    border:1px solid #FFC9B6;
    background: transparent;
    color: #FFF6F3;
}
/deep/ input::-webkit-input-placeholder {
    color: #FFF6F3;
}
input::-moz-input-placeholder {
    color: #FFF6F3;
}
input::-ms-input-placeholder {
    color: #FFF6F3;
}
/deep/ textarea::-webkit-input-placeholder {
    color: #FFF6F3;
}
textarea::-moz-input-placeholder {
    color: #FFF6F3;
}
textarea::-ms-input-placeholder {
    color: #FFF6F3;
}
>>>.el-textarea__inner{
    background: transparent;
    color: #FFF6F3;
    width:642px;
    height:138px;
    border-radius:8px;
    border:1px solid #FFC9B6;
}
>>>.el-input__count{
    background: transparent;
    color: #fff;
}
.qing{
    font-size:13px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:18px;
    text-align: center;
    margin-top: 15px;
}
.lijizx{
    width:642px;
    height:48px;
    background:rgba(255,255,255,1);
    border-radius:25px;
    margin: auto;
    text-align: center;
    font-size:15px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(248,120,75,1);
    line-height:48px;
    margin-top: 25px;
    cursor:pointer;
}
.lijizx:hover{
    background:#F3F3F3;
}
.buttom{
    width:100%;
    height:130px;
    background:rgba(17,17,17,1);
}
.buttom_ul{
    width: 100%;
    height:167px;
    padding-left:253px;
}
.buttom_li{
    width: 31.5%;
    height:167px;
    float: left;
    color: #A0A0A0;
    /* background: chartreuse; */
}
.buttom_p{
    font-size:16px;
    font-family:PingFangSC-Light,PingFang SC;
    font-weight:300;
    color:rgba(160,160,160,1);
    line-height:21px;
    letter-spacing:1px;
    /* margin-left:60px; */
    padding-top:35px;
}
.buttom_ce{
    width:1px;
    height:31px;
    background: #fff;
    margin-top: 85px;
    margin-left: 60px;
}
.buttom_bo{
    font-size:13px;
    font-family:PingFangSC-Light,PingFang SC;
    font-weight:300;
    color:rgba(100,100,100,1);
    line-height:33px;
    padding-top:30px;
}
.buttom_bo a{
    font-size:13px;
    color:rgba(100,100,100,1);
	/* margin-left: 36%; */
}
.buttom_bo span{
    font-size:13px;
    color:rgba(100,100,100,1);
	/* margin-left: 30px; */
}
.mefen_p{
    font-size:20px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(10,22,49,1);
    line-height:28px;
    margin-top: 33px;
}
.mefen_p1{
    font-size:15px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(122,134,164,1);
    line-height:21px;
    margin-top: 7px;
}
.mefen_p2{
    font-size:15px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(122,134,164,1);
    line-height:21px;
}
.mefen_p3{
    font-size:20px;
    font-family:DIN-BoldItalic,DIN;
    font-weight:normal;
    color:rgba(249,122,125,1);
    line-height:24px;
}
.mefen_ul{
    width: 100%;
    height: 15px;
    margin-top: 15px;
}
.mefen_li{
    float: left;
    margin-left: 17px;
}
.triangle-up{
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 14px solid #F97A7D;
}
.me_fir{
    position: absolute;
    bottom: 96px;
    left: 92px;
}
.me_two{
    position: absolute;
    bottom: 104px;
    left: 278px;
}
.me_thr{
    position: absolute;
    bottom: 99px;
    left: 451px;
}
.me_fou{
    position: absolute;
    bottom: 82px;
    left: 632px;
}
.me_fiv{
    position: absolute;
    bottom: 82px;
    left: 830px;
}
.me_six{
    position: absolute;
    bottom: 74px;
    left: 1016px;
}
.top_ljzx{
    width:175px;
    height:44px;
    background:rgba(255,255,255,1);
    box-shadow:0px 20px 30px 0px rgba(98,24,11,0.19);
    border-radius:43px;
    font-size:20px;
    font-family:PingFangSC-Medium,PingFang SC;
    animation: scaleDrew 2.5s ease-in-out infinite;
    font-weight:500;
    color:rgba(253,133,91,1);
    line-height:44px;
    text-align: center;
    position: absolute;
    top: 63%;
    left: 21%;
}
.animated {
    animation-duration: 1.2s;
    animation-fill-mode: both;
}
@keyframes scaleDrew {
    0% {
        transform: scale(1);
    }

    25% {
        transform: scale(1.1);
    }

    50% {
        transform: scale(1);
    }

    75% {
        transform: scale(1.1);
    }
}
>>>.el-input__inner:focus{
    border-color:#fff;
    border: 2px solid #fff;
}
>>>.el-textarea__inner:focus{
    border-color:#fff;
    border: 2px solid #fff;
}
>>>.el-input__inner:hover {
    border-color: #fff;
    border: 2px solid #fff;
}
>>>.el-textarea__inner:hover {
    border-color: #fff;
    border: 2px solid #fff;
}
>>>.el-textarea .el-input__count {
    color: #fff;
    background: transparent;
    position: absolute;
    font-size: 12px;
    bottom: 5px;
    right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue